<div class="stepper" *ngIf="application">
  <ul class="steps">
    <li *ngIf="currentProductStatusNumber >= 1" [class.current]="currentProductStatusNumber == 1" [class.completed]="currentProductStatusNumber >= 1">
      Fülle bitte Dein Profil und Produktblatt aus
    </li>
    <li *ngIf="currentProductStatusNumber >= 2" [class.current]="currentProductStatusNumber == 2" [class.completed]="currentProductStatusNumber >= 2">
      Gerade prüfen wir Deine Bewerbung
    </li>
    <li *ngIf="currentProductStatusNumber == 3" [class.current]="currentProductStatusNumber == 3" [class.completed]="currentProductStatusNumber == 3">
      Leider können wir Dein Produkt so noch nicht veröffentlichen. Das voilà! Team wird dich in Kürze kontaktieren.
    </li>
    <li *ngIf="currentProductStatusNumber >= 4" [class.current]="currentProductStatusNumber == 4" [class.completed]="currentProductStatusNumber >= 4">
      Deine Bewerbung ist freigegeben. Ob Du beim Pitch dabei bist, erfährst Du per Mail.
    </li>
    <li *ngIf="currentProductStatusNumber == 5" [class.current]="currentProductStatusNumber == 5" [class.completed]="currentProductStatusNumber == 5">
      Herzlichen Glückwunsch! Du bist beim Pitch dabei.<br />
      Info: Welche Händler für Dein Produkt abgestimmt haben, siehst Du nach dem Pitch-Termin auf der rechten Seite.
    </li>
    <li *ngIf="currentProductStatusNumber == 6" [class.current]="currentProductStatusNumber == 6" [class.completed]="currentProductStatusNumber == 6">
      Schade! Leider hat es dieses Mal nicht gereicht. Wir freuen uns, wenn Du Dich für den nächsten Pitch wieder bewirbst.<br />
      Info: Welche Händler für Dein Produkt abgestimmt haben, siehst Du nach dem Pitch-Termin auf der rechten Seite.
    </li>
  </ul>
</div>
